import {
  CalendarGoalsContainer,
  FinancialsContainer,
  OrganizationPermissions,
  OrganizationStations,
  OrganizationUsersContainer,
  TreesContainer,
  VendorsContainer,
  MiscContainer,
} from "../../containers";
import { PERMISSIONS_KEY } from "../../constants/permissions";

export const tabs = [
  {
    id: 1,
    label: "Stations",
    icon: "Archive",
    TabElement: <OrganizationStations />,
  },
  {
    id: 2,
    label: "Materials",
    icon: "Codesandbox",
    TabElement: <TreesContainer />,
  },
  {
    id: 3,
    label: "Vendors",
    icon: "Shop",
    TabElement: <VendorsContainer />,
  },
  {
    id: 4,
    label: "Users",
    icon: "User",
    TabElement: <OrganizationUsersContainer />,
  },
  {
    id: 5,
    label: "Permissions",
    icon: "Lock",
    TabElement: <OrganizationPermissions />,
  },
  {
    id: 6,
    label: "Misc",
    icon: "MoreHorizontal",
    TabElement: <MiscContainer />,
  },
  {
    id: 7,
    label: "Calendar Goals",
    icon: "Calendar",
    TabElement: <CalendarGoalsContainer />,
  },
  {
    id: 8,
    label: "Financials",
    icon: "DollarSign",
    permission: PERMISSIONS_KEY.FINANCIALS,
    TabElement: <FinancialsContainer />,
  },
  {
    id: 9,
    label: "Settings",
    icon: "Settings",
    // TabElement: WorkOrderProd,
  },
];
